import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";

class GradeTimingStore {
  gradeTiming = [];
  getClass = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      getClass: observable,
      gradeTiming: observable,
      total: observable,
      loading: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getAllClass: action,
    });
    this.rootStore = rootStore;
  }

  async getCompany({ companyName }) {
    var postData = { name: companyName };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=searchCompany", "postData=" + base64Input);
    console.log(response);
  }
  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      deviceGrpOffSet: 0,
      offset: offset,
      limit: limit,
      deviceGrpSize: 10,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/gradeTiming/getGradeList", {
        params: postData,
      });

    this.gradeTiming = response?.data?.Grades;

    this.total = parseInt(response?.data?.TotalCount);

    this.loading = false;
  }
  async deleteRecord({ grade_Id }) {
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/gradeTiming/deleteGrade", {
        params: {
          grade_Id: grade_Id,
        },
      });
    return response;
  }

  async addData(postData) {
    var gradeDetails = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/gradeTiming/updateGrade", gradeDetails);

    return response.data;
  }
  async getGradeTimingData({ grade_Id }) {
    var postData = { grade_Id: grade_Id, limit: 1, offset: 0 };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/gradeTiming/getGradeList", {
        params: postData,
      });

    return response.data.Grades[0];
  }

  async getAllClass() {
    // console.log("vehicle list")
    var postData = null;
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/notifications/getAllClass");
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=notification&a=getAllClass",
          "postData=" + base64Input,
        );
    }

    // console.log(response?.data?.data, "post")

    this.getClass = response?.data?.data;
    return response?.data?.data;
  }
}

export default GradeTimingStore;
